import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from '../../../adapter-vue';
import Overlay from '../../common/Overlay/index.vue';

interface IProps {
  visible: boolean;
  popDirection: 'top' | 'right' | 'bottom' | 'left';
  useMask?: boolean;
  isFullScreen?: boolean | undefined;
  overlayColor?: string | undefined;
  drawerStyle?: {
    bottom?: Record<string, any> | undefined;
    right?: Record<string, any> | undefined;
    left?: Record<string, any> | undefined;
    top?: Record<string, any> | undefined;
  };
}

interface IEmits {
  (e: 'onOverlayClick', event: Event): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    visible: { type: Boolean, default: true },
    popDirection: { default: 'bottom' },
    useMask: { type: Boolean, default: true },
    isFullScreen: { type: [Boolean, null], default: true },
    overlayColor: null,
    drawerStyle: { default: () => ({}) }
  },
  emits: ["onOverlayClick"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (e: 'onOverlayClick', event: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, popDirection: 'top' | 'right' | 'bottom' | 'left', useMask: boolean, isFullScreen: boolean | undefined, overlayColor?: string | undefined, drawerStyle: {
    bottom?: Record<string, any> | undefined;
    right?: Record<string, any> | undefined;
    left?: Record<string, any> | undefined;
    top?: Record<string, any> | undefined;
  } }




const drawerDomRef = ref<HTMLElement>();
const overlayDomInstanceRef = ref<InstanceType<typeof Overlay>>();
const isDrawerShow = ref<boolean>(false);

const styles = ref(props.drawerStyle[props.popDirection] || {});

watch(() => props.visible, (visible: boolean) => {
  if (visible) {
    isDrawerShow.value = true;
  } else {
    setTimeout(() => {
      isDrawerShow.value = false;
    }, 150);
  }
}, {
  immediate: true,
});

function onOverlayClick(e: Event) {
  emits('onOverlayClick', e);
}

expose({
  drawerDomRef,
  overlayDomRef: overlayDomInstanceRef.value?.overlayDomRef,
});

return { __sfc: true,emits, props, drawerDomRef, overlayDomInstanceRef, isDrawerShow, styles, onOverlayClick, Overlay }
}

})